
import React from "react";
import { Archive } from "lucide-react";

interface ArchivedGamesToggleProps {
  showArchived: boolean;
  onToggle: () => void;
}

const ArchivedGamesToggle = ({ showArchived, onToggle }: ArchivedGamesToggleProps) => {
  return (
    <button 
      onClick={onToggle}
      className="flex items-center justify-center w-full gap-2 py-2 text-sm text-gray-500 hover:text-gray-700 transition-colors"
    >
      <Archive className="h-4 w-4" />
      {showArchived ? "Hide Completed Games" : "Show Completed Games"}
    </button>
  );
};

export default ArchivedGamesToggle;
